import { getUkCity } from '../../utils/commonSelectors'

export const selectUk = state => state.init.uk
export const selectUkCity = getUkCity
export const selectUkCountry = state => state.init.uk.country_obj
export const selectUkId = state => state.init.uk.id
export const selectUkOffices = state => state.init.uk.offices
